import moment from 'moment'
import * as dateUtils from 'shared_src/date'

const {
  fhirDate,
  standardDate,
  isValidDate,
  isValidFHIRDate,
  fhirDateTime,
  standardDateTime,
  isValidDateTime,
  isValidFHIRDateTime,
  dueDateString,
  mediumDate,
  fhir2form,
  FHIR_DATE,
  STANDARD_DATE
} = dateUtils

const _fhirDate = (date, fromFormat) => {
  const a = moment(date, fromFormat).format(FHIR_DATE)
  return a
}

/*

This is a temporary fix for date formatting on the front end.
When we moved the Date formatting to the shared_src this bug
broke all the fhir date formatting the the app.

- Taylor
*/
const form2fhir = a => {
  const b = _fhirDate(a)
  return b
}

// -This is the end of my fix


dateUtils.form2fhir = form2fhir

export {
  fhirDate,
  standardDate,
  isValidDate,
  isValidFHIRDate,
  fhirDateTime,
  standardDateTime,
  isValidDateTime,
  isValidFHIRDateTime,
  dueDateString,
  mediumDate,
  form2fhir,
  fhir2form,
  STANDARD_DATE,
  FHIR_DATE
}

export default dateUtils
